const ctx = require.context('../assets/bg', /* recursive */ false, /\.(mp4)$/i)
const VIDEO_URLS = ctx.keys().map(ctx)

export default VIDEO_URLS
